import type { CylinderSurface } from '@repo/api-contracts';
import {
  type CylinderParams,
  deCylinderizeRect,
  type PhotoSize,
  photoPercentRectToPx,
  type Rect,
} from '@repo/warp-engine';
import type { PhotoDimensions } from '../types';

/** 사진 크기({widthPx, heightPx})를 엔진 사진 크기({width, height})로 바꾼다. 그대로 넘기면 NaN 이 된다. */
export const toEnginePhoto = ({ widthPx, heightPx }: PhotoDimensions): PhotoSize => ({
  width: widthPx,
  height: heightPx,
});

/** 저장한 보이는 사각형(points, 사진 %)을 사진 px 사각형으로 바꾼다(ADR-0007 부록 A). */
const visibleRectPx = (
  [topLeft, topRight, , bottomLeft]: CylinderSurface['points'],
  photo: PhotoDimensions,
): Rect =>
  photoPercentRectToPx(
    {
      left: topLeft.x,
      top: topLeft.y,
      width: topRight.x - topLeft.x,
      height: bottomLeft.y - topLeft.y,
    },
    toEnginePhoto(photo),
  );

/**
 * cylinder 서피스의 저장 표현을 엔진 원통 입력으로 바꾸는 어댑터(ADR-0007 부록 A).
 * photo 는 그 색상의 그 면 사진 크기(colors[].faces.<면>.photoSize)다. degree 는 0 이다.
 */
export const cylinderParamsOf = (
  surface: CylinderSurface,
  photo: PhotoDimensions,
): CylinderParams => {
  const area = deCylinderizeRect(visibleRectPx(surface.points, photo));

  return {
    area,
    upSide: surface.topCurveRatio * area.height,
    downSide: surface.bottomCurveRatio * area.height,
    degree: 0,
  };
};
